import { render, staticRenderFns } from "./update-table.vue?vue&type=template&id=c9ff7c52&"
import script from "./update-table.vue?vue&type=script&lang=js&"
export * from "./update-table.vue?vue&type=script&lang=js&"
import style0 from "./update-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports